import actionTypes from "../actions/actionTypes";

const oAuthUser = (
  state = {
    isLoading: false,
    data: null,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_OAUTH_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.CREATE_USER_OAUTH_SUCCESS:
      return { isLoading: false, data: action.res.Data };

    case actionTypes.CREATE_USER_OAUTH_FAILURE:
      return { isLoading: false, data: null };

    default:
      return state;
  }
};

export default oAuthUser;
